import { SET_IS_EMBEDDED } from "../types/embeddedType";

const initialState = {
    isEmbedded: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_EMBEDDED:
            return {
                ...state,
                isEmbedded: action.payload,
            };

        default:
            return state;
    }
};
